import React, { createContext, useState, useEffect } from "react";
import { loadUserConfig, loadUserConfig2 } from "../constants/config"; // Asegúrate de importar correctamente las funciones

// Crear el contexto
const UserConfigContext = createContext();

// Proveedor del contexto
const UserConfigProvider = ({ children }) => {
  const [config1, setConfig1] = useState(null); // Guardar solo la configuración de loadUserConfig
  const [config2, setConfig2] = useState(null); // Guardar solo la configuración de loadUserConfig2

  // Cargar la configuración al iniciar la aplicación
  useEffect(() => {
    const fetchUserConfig = async () => {
      try {
        const configData1 = await loadUserConfig(); // Carga solo la configuración de loadUserConfig
        const configData2 = await loadUserConfig2(); // Carga solo la configuración de loadUserConfig2
        
        // Almacenar cada configuración por separado
        setConfig1(configData1);
        setConfig2(configData2);
      } catch (error) {
        console.error("Error al cargar la configuración:", error);
      }
    };

    fetchUserConfig();
  }, []); // Solo se ejecuta una vez al iniciar

  return (
    <UserConfigContext.Provider value={{ config1, config2 }}>
      {children}
    </UserConfigContext.Provider>
  );
};

export { UserConfigProvider, UserConfigContext };
